<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="28"
		height="28"
		viewbox="0 0 28 28"
		fill="none"
	>
		<path
			d="M27.6004 13.9999C27.6004 6.48889 21.5114 0.399902 14.0004 0.399902C6.48938 0.399902 0.400391 6.48889 0.400391 13.9999C0.400391 20.3778 4.79156 25.7296 10.7152 27.1995V18.1561H7.91085V13.9999H10.7152V12.2091C10.7152 7.58016 12.8101 5.43462 17.3547 5.43462C18.2164 5.43462 19.7031 5.60381 20.3113 5.77245V9.53965C19.9904 9.50592 19.4328 9.48905 18.7403 9.48905C16.5104 9.48905 15.6487 10.3339 15.6487 12.53V13.9999H20.091L19.3278 18.1561H15.6487V27.5004C22.3829 26.6871 27.6009 20.9533 27.6009 13.9999H27.6004Z"
			fill="#000"
		></path>
	</svg>
</template>
